// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__W1I8w","logotype":"default_logotype__CS2l6"};